import * as React from "react";
const SvgFiRrSeedling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-seedling_svg__a)">
      <path
        fill="#062147"
        d="M23.25.601a2.28 2.28 0 0 0-1.802-.586c-5.655.654-8.255 4.435-9.447 7.57C10.809 4.45 8.208.67 2.552.015A2.29 2.29 0 0 0 .75.601a2.26 2.26 0 0 0-.737 1.722c.087 3.27 1.156 5.867 3.18 7.72 2.606 2.388 6.081 2.863 7.809 2.943V23a1 1 0 1 0 2 0V12.986c1.726-.08 5.201-.555 7.809-2.943 2.021-1.853 3.092-4.45 3.178-7.72a2.26 2.26 0 0 0-.736-1.722zM4.532 8.56c-1.6-1.472-2.448-3.588-2.52-6.289a.26.26 0 0 1 .088-.194A.28.28 0 0 1 2.29 2c6.563.76 8.203 6.54 8.59 8.973-1.509-.099-4.316-.545-6.348-2.414m17.456-6.288c-.072 2.701-.92 4.817-2.52 6.29-2.033 1.87-4.845 2.314-6.353 2.413.378-2.432 2.002-8.21 8.594-8.973.091 0 .157.046.19.076a.26.26 0 0 1 .087.193z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-seedling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSeedling;
